import { MessageBox } from 'element-ui'
import { oauthLogin } from '@/utils/oauth'

$(document).ajaxComplete(function (event, jqXHR, ajaxOptions, res) {
  // if (jqXHR.status === 401) {
  //   $vue.$store.commit("userinfo/loginOut",401)  
  // }
  if((jqXHR.responseJSON && jqXHR.responseJSON.code && jqXHR.responseJSON.code === 401) || jqXHR.status === 401) {
    MessageBox.alert('登陆超时，请重新登录', '登录超时', {
      confirmButtonText: '重新登录',
      showClose: false,
      type: 'warning'
    }).then(() => {
      oauthLogin()
    })   
  }
});

var obj=[
    {path:"/userMent/listUser",//用户管理
      viewpage:false,//是否晒看页面
      roles:[
        {type:"getListUser",name:"查询用户及列表",},
        {type:"addUser",name:"新増用户"},
        {type:"modifyUser",name:"修改用户"},
      ]},

    {path:"/roleMent/listRole",//角色管理
      viewpage:false,//是否晒看页面
      roles:[
        {type:"getListRole",name:"查看角色及权限",},
        {type:"addUserRole",name:"新增角色名称及权限"},
        {type:"modifyUserRole",name:"修改角色名称及权限"},
      ]},

    {path:"/columnMent/column",//栏目管理
      viewpage:false,//是否晒看页面
      roles:[
        {type:"getListColumnMent",name:"查询栏目及列表",},
        {type:"addUserColumnMent",name:"新增栏目"},
        {type:"modifyColumnMent",name:"编辑栏目"},
      ]},

    {path:"/specialMent/specialMent",//专题管理
      viewpage:false,//是否晒看页面
      roles:[
        {type:"getListSpecialMent",name:"查看专题",},
        {type:"addUserSpecialMent",name:"新增专题"},
        {type:"modifySpecialMent",name:"修改专题"},
        {type:"deleteSpecialMent",name:"删除专题"},
      ]},

    {path:"/submitMent/submit",//投稿管理
      viewpage:false,//是否晒看页面
      roles:[
        {type:"getMyselfSubmit",name:"查询投稿人自有稿件及列表",},
        {type:"getAllSubmit",name:"查询所有投稿人稿件及列表"},
        {type:"addSubmit",name:"新增稿件"},
        {type:"modifySubmit",name:"编辑稿件"},
        {type:"lookSubmit",name:"预览稿件"},
        {type:"sendSubmit",name:"投稿稿件"},
        {type:"rollBackSubmit",name:"撤回稿件"},
      ]},

    {path:"/submitMent/submit",//投稿管理
      viewpage:false,//是否晒看页面
      roles:[
        {type:"getMyselfSubmit",name:"查询投稿人自有稿件及列表",},
        {type:"getAllSubmit",name:"查询所有投稿人稿件及列表"},
        {type:"addSubmit",name:"新增稿件"},
        {type:"modifySubmit",name:"编辑稿件"},
        {type:"lookSubmit",name:"预览稿件"},
        {type:"sendSubmit",name:"投稿稿件"},
        {type:"rollBackSubmit",name:"撤回稿件"},
      ]},

    {path:"/manuscriptMent/examine",//审核管理
      viewpage:false,//是否晒看页面
      roles:[
        {type:"getListExamine",name:"查询稿件及列表",},
        {type:"modifyExamine",name:"编辑稿件"},
        {type:"isOkExamine",name:"审核稿件"},
        {type:"lookExamine",name:"查看稿件"},
        {type:"copyExamine",name:"一键复制"},
      ]},

    {path:"/manuscriptMent/release",//发布管理
      viewpage:false,//是否晒看页面
      roles:[
        {type:"getListRelease",name:"查询稿件及列表",},
        {type:"upDownRelease",name:"发布/下架稿件"},
        {type:"lookRelease",name:"查看稿件"},
      ]},
    {path:"/manuscriptMent/recommend",//推荐管理
      viewpage:false,//是否晒看页面
      roles:[
        {type:"getListRecommend",name:"查询稿件及列表",},
        {type:"cancelRecommend",name:"推荐/取消推荐稿件"},
        {type:"setRecommend",name:"设置排序"},
      ]},
  ]







// WEBPACK FOOTER //
// ./src/others/Queryextends.js